/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const addStandardizedInstallOptInRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc',
  rpcName: 'addStandardizedInstallOptIn',
  auth: 'app',
  fingerprint: 'RYYUZ3g3kc6OUe2e_r4XmUa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removeStandardizedInstallOptInRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc',
  rpcName: 'removeStandardizedInstallOptIn',
  auth: 'app',
  fingerprint: 'wKzupauzcY2OUe2e_r4XmUa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStandardizedInstallOptInRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc',
  rpcName: 'getStandardizedInstallOptIn',
  auth: 'app',
  fingerprint: '1NatNx2zU13ud7M-AHOs6Ua-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchCheckStandardizedInstallRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc',
  rpcName: 'batchCheckStandardizedInstall',
  auth: 'app',
  fingerprint: 'N5Kn6wGt2j1J91NO386bTEa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};